import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Ghost } from "lucide-react";

export default function NotFound() {
  return (
    <div className="h-screen w-full flex items-center justify-center relative z-10 p-6" data-testid="not-found">
      <div className="glass-panel rounded-3xl p-10 text-center max-w-md">
        <Ghost className="h-10 w-10 text-blue-500 mx-auto mb-3" />
        <h1 className="font-display text-3xl font-semibold">404</h1>
        <p className="text-muted-foreground mt-2">No encontramos lo que buscabas.</p>
        <Link to="/" className="inline-block mt-6">
          <Button className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="notfound-home">Volver al inicio</Button>
        </Link>
      </div>
    </div>
  );
}
